import React from 'react';
import cx from 'classnames';
import { SkeletonSimple } from '~components/skeleton';

import './style.scss';

const FormSkeleton = ({ align = 'default', className }) => {
  return (
    <div
      className={cx(`c-form-skeleton c-form-skeleton--${align}`, {
        [className]: !!className,
      })}
    >
      <SkeletonSimple theme="primary" className="c-skeleton-simple__item c-form-skeleton__label" />
      <SkeletonSimple theme="primary" className="c-skeleton-simple__item c-form-skeleton__input" />
      <SkeletonSimple theme="primary" className="c-skeleton-simple__item c-form-skeleton__label" />
      <SkeletonSimple theme="primary" className="c-skeleton-simple__item c-form-skeleton__input" />
      <SkeletonSimple theme="primary" className="c-skeleton-simple__item c-form-skeleton__label" />
      <SkeletonSimple theme="primary" className="c-skeleton-simple__item c-form-skeleton__input" />
    </div>
  );
};

export default FormSkeleton;
